export default __webpack_public_path__ + "static/media/S-048.a9644bc8.png";